import { ArrowUpCircleFill } from 'react-bootstrap-icons';
import { LoadingSpinner } from '../../../components/LoadingSpinner/LoadingSpinner';

interface SendMessageButtonProps {
  active: boolean;
  isLoading?: boolean;
}
const SendMessageButton = ({
  active,
  isLoading = false,
}: SendMessageButtonProps) => {
  return (
    <button
      type="submit"
      disabled={!active || isLoading}
      className="chat-prompt-input__send-button"
      style={{ cursor: active && !isLoading ? 'pointer' : 'default' }}
    >
      {isLoading ? (
        <LoadingSpinner size={24} showText={false} color="primary" />
      ) : (
        <ArrowUpCircleFill fill={active ? '#654b78' : '#D9D9D9'} size={32} />
      )}
    </button>
  );
};

export default SendMessageButton;
